import styled from 'styled-components';

import { CONTAINER_RATIO } from '~/src/common/components/GridCard/layout';
import { GridCardFormat } from '~/src/common/components/GridCard/types';

import ImageObjectFit from '../../ImageObjectFit';

export const Image = styled(ImageObjectFit)`
  position: absolute;
`;

export const Container = styled.article<{ format: GridCardFormat }>`
  position: relative;
  overflow: hidden;

  aspect-ratio: ${({ format }) => CONTAINER_RATIO[format]};

  width: 100%;
  height: 100%;

  z-index: 2;
  border-radius: ${({ theme }) => theme.layout.borderRadius};

  &[role='button'] {
    cursor: pointer;
  }
`;
